<template>
  <section class="contact-d" aria-labelledby="welcome-contact-title">
    <span class="contact-d__tag">Contáctanos</span>
    <h2 id="welcome-contact-title" class="contact-d__title">
      Puedes comunicarte a la línea de atención a clientes de HIR Casa llamando al teléfono gratuito
    </h2>

    <div class="contact-d__cards">
      <a
        v-for="card in cards"
        :key="card.title"
        class="contact-d__card"
        :href="card.href"
        :target="card.external ? '_blank' : undefined"
        :rel="card.external ? 'noopener' : undefined"
      >
        <span class="contact-d__icon"><img :src="card.icon" alt="" aria-hidden="true" /></span>
        <span class="contact-d__copy">
          <span class="contact-d__card-title">{{ card.title }}</span>
          <span class="contact-d__card-detail">
            <template v-for="(line, i) in card.lines" :key="i"
              >{{ line }}<br v-if="i < card.lines.length - 1"
            /></template>
          </span>
        </span>
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
import phoneIcon from '../../../assets/bienvenida-desktop/icon-telefono.svg'
import whatsappIcon from '../../../assets/bienvenida-desktop/icon-whatsapp.svg'

const cards = [
  {
    icon: phoneIcon,
    title: 'LLámanos',
    lines: ['800 447 2272 y 55 5511 9910', '(opción 2)'],
    href: 'tel:+525555119910',
    external: false
  },
  {
    icon: whatsappIcon,
    title: 'WhatsApp',
    lines: ['5576659885', '(opción 1)'],
    href: 'http://wa.me/5215576659885',
    external: true
  }
]
</script>

<style scoped>
.contact-d {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-6);
  width: 100%;
  max-width: 962px;
  padding: var(--ds-space-6) 99px;
  box-sizing: border-box;
  overflow: hidden;
  background: var(--ds-tertiary);
  border-radius: 24px;
}

.contact-d__tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 156px;
  padding: var(--ds-space-3);
  box-sizing: border-box;
  border-radius: 9999px;
  background: var(--ds-grey-50);
  color: var(--ds-purple-500);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.contact-d__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
}

.contact-d__cards {
  display: flex;
  align-items: stretch;
  gap: var(--ds-space-5);
  width: 100%;
}

.contact-d__card {
  display: flex;
  flex: 0 0 370px;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-4);
  padding: var(--ds-space-4) var(--ds-space-3);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 4px;
  color: var(--ds-text-body);
  text-decoration: none;
}

.contact-d__icon {
  display: flex;
  flex: 0 0 56px;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 38px;
  background: var(--ds-tertiary);
}
.contact-d__icon img {
  width: 24px;
  height: 24px;
}

.contact-d__copy {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  min-width: 0;
}
.contact-d__card-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.contact-d__card-detail {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

@media (max-width: 1024px) {
  .contact-d {
    padding: var(--ds-space-6) var(--ds-space-5);
  }
  .contact-d__title {
    min-height: 88px;
  }
  .contact-d__card {
    flex: 1 1 0;
    min-width: 0;
  }
}

@media (max-width: 599px) {
  .contact-d {
    gap: var(--ds-space-5);
    padding: var(--ds-space-5) var(--ds-space-4);
  }
  .contact-d__cards {
    flex-direction: column;
  }
  .contact-d__card {
    flex: none;
  }
}
</style>
